import { render, staticRenderFns } from "./clickyarseo.vue?vue&type=template&id=1b82238e&scoped=true"
import script from "./clickyarseo.vue?vue&type=script&lang=js"
export * from "./clickyarseo.vue?vue&type=script&lang=js"
import style0 from "./clickyarseo.vue?vue&type=style&index=0&id=1b82238e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b82238e",
  null
  
)

export default component.exports